import classNames from 'classnames';
import * as React from 'react';

import * as styles from './index.css';
import { trackFastLinkClick, trackFastLinksView } from './tracking';
import { IFastLink } from '../../../common/state/app_state';
import { IJsonQuery } from '../../../json_query';
import { getTotalPagesCount } from '../../../utils/pagination';

export interface IFastLinksProps {
  fastLinks: IFastLink[];
  aggregatedOffers: number;
  jsonQuery: IJsonQuery;
  offersPerPage: number;
}

export class FastLinks extends React.Component<IFastLinksProps> {
  public componentDidMount() {
    trackFastLinksView(this.getTrackingEventLabel());
  }

  public render() {
    const { fastLinks, aggregatedOffers, offersPerPage } = this.props;

    if (!fastLinks || !fastLinks.length) {
      return null;
    }

    const totalPages = getTotalPagesCount(offersPerPage, aggregatedOffers);

    return (
      <div className={styles['wrapper']}>
        <div className={classNames(styles['container'], totalPages > 1 && styles['container-shifted'])}>
          <span className={styles['header']}>Вместе с этим также ищут:</span>
          {fastLinks.map(({ title, uri }, index) => (
            <a key={index} className={styles['link']} href={uri} onClick={this.handleClick}>
              {title}
            </a>
          ))}
        </div>
      </div>
    );
  }

  private handleClick = () => {
    trackFastLinkClick(this.getTrackingEventLabel());
  };

  private getTrackingEventLabel = (): string => {
    const { aggregatedOffers, offersPerPage } = this.props;

    return aggregatedOffers < offersPerPage + 1 ? 'withoutPagination' : 'withPagination';
  };
}
